'use client';

import type { FC, ReactNode } from 'react';
import { cn } from '../../utils/cn';

interface ModalSheetProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
  align?: 'center' | 'start';
}

export const ModalSheet: FC<ModalSheetProps> = ({ isOpen, onClose, children, className, align = 'center' }) => {
  if (!isOpen) return null;

  return (
    <div
      data-blocks-page-scroll
      className={cn(
        'fixed inset-0 bg-black/80 flex justify-center z-[1100] p-4',
        align === 'center' ? 'items-center' : 'items-start pt-[calc(16px+var(--tg-viewport-safe-area-inset-top,0px)+var(--tg-viewport-content-safe-area-inset-top,0px))]',
      )}
      onClick={onClose}
    >
      <div
        className={cn(
          'bg-surface-modal border border-accent-blue/30 rounded-2xl w-full max-w-[400px] flex flex-col overflow-hidden shadow-[0_20px_40px_rgba(0,0,0,0.3)]',
          className,
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};
